// eslint-disable-next-line import/prefer-default-export
export const PHONE_TYPES = {
  MOBILE: 'MOBILE',
  LANDLINE: 'LANDLINE',
  VOIP: 'VOIP',
};
